import {
    COMPARISON_BASKET_REQUEST_START,
    COMPARISON_BASKET_REQUEST_SUCCESS,
    COMPARISON_BASKET_REQUEST_ERROR,
} from 'state/actions/comparison_basket'

import { C2W_EVENT_TYPES } from '@wotfe/client2web'

const defaultState = {
    basketContents: [],
    basketMaxCount: 0,
    isLoading: false,
    isFull: true,
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
    case COMPARISON_BASKET_REQUEST_START: {
        return {
            ...state,
            isLoading: true,
        }
    }
    case COMPARISON_BASKET_REQUEST_SUCCESS: {
        const { basketContents, basketMaxCount } = action.payload
        return {
            ...state,
            isLoading: false,
            basketContents,
            basketMaxCount,
            isFull: basketContents.length === basketMaxCount,
        }
    }
    case C2W_EVENT_TYPES.UPDATE_COMPARISON_BASKET: {
        const { basketContents, basketMaxCount } = action.data
        return {
            ...state,
            isLoading: false,
            basketContents,
            basketMaxCount,
            isFull: basketContents.length === basketMaxCount,
        }
    }
    case COMPARISON_BASKET_REQUEST_ERROR: {
        return {
            ...state,
            isLoading: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/comparison_basket.js